// Quotation Signed Stage  Btn related codes goes here

// NPM Imports
import React, { Fragment } from "react";
import { Button } from "@revvsales/components";

// Components Imports

// Declarations

export default function QuotationSignedBtns(props) {
  return (
    <Fragment>
      <Button
        className="revv-btn-secondary"
        onClick={() => props.togglePopUp("download", true)}
        id={"Download".replace(/ +/g, "-").toLowerCase()}
        data-test="download-doc-stage-btn">
        Download
      </Button>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationSignedBtns.js